import React from "react";

import TextInput from '../../components/form/TextInput';
import SelectAjax from "../../components/form/SelectAjax";
import Select from "../../components/form/Select";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import BtBloco from '../../components/buttons/BtBloco';
import ComponentBloco from "../blocos/Component";
import DAYS from "../../data/Days";
import "./component.css";
import SequenciaBlocos from './SequenciaBlocos';
import BlocosBox from './BlocosBox';
import Alert from "../../components/alert/Alert";
import SimpleAlert from "../../components/alert/types/SimpleAlert";
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import {FormDataToJson} from '../../utils/json/Json';

class Component extends React.Component {
  constructor(props){
    super(props);

    this.handlerBloco = this.handlerBloco.bind(this);
    this.removeItemList = this.removeItemList.bind(this);
    this.toggleBoxes = this.toggleBoxes.bind(this);
    this.addBloco = this.addBloco.bind(this);
    this.handleQntDia = this.handleQntDia.bind(this);
    this.onRemoveBloco = this.onRemoveBloco.bind(this);

    this.state = {
      wrapper:Random(7),
      listagemClass:"listagem",
      blocoClass:"js-bloco-wrapper bloco-planilha-wrapper",
      wrapperId:Random(7),
      blocosSequenciaId:Random(7),
      stepBlocos:[],
      blocos:[],
      dados:props.dados,
      qntDias:props.qntDias,
      ativo:0,
      update:false,
      strings:STRINGS[window.LANGUAGE],
    };

  }//end constructor

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  componentWillUpdate(nextProps, nextState) {
  }

  handleQntDia (__args__){
    this.setState({qntDias:__args__.value});
  }

  onRemoveBloco (e){
    e.preventDefault();

    /*const index = e.currentTarget.getAttribute('data-position');
    const { atencao, impossivelRemover } = this.state.strings;

    if(!index){
      let msg = {
        title: atencao,
        text: impossivelRemover
      };
      Dialog.create(msg);

      return false;
    }

    const _ativo = 0;
    const _arr = [...this.state.dados.blocos];
    console.log(index);
    console.log(_arr);
    _arr.splice( index, 1 );
console.log(_arr);
    this.setState({
      dados:{blocos:[]},
      ativo:_ativo
    });*/

  }

  removeItemList (e){
    e.preventDefault();

    var _item = e.target.closest(".item-listagem");
    _item.remove();
  }//end remove item list

  handlerBloco = (__args__) => {
    let modal = new Alert();

    if(!this.state.qntDias){
      modal.open({
        page:<SimpleAlert title="Atenção" message="Antes de adicionar um bloco selecione a quantidade de dias da Planilha" />,
        animation:Alert.ANIMATION_INCREASE
      });
      return false;
    }

    var _self = this;
    Requisitions({
			url:WS.blocos.detalhe,
			data:{id:__args__.value},
			sucess:function(data){
        _self.addBloco(data.item);
			},
			error:function(data){

			}
		});
  }//end handler bloco

  addBloco (__args__){

    let modal = new Alert();

    if(this.state.dados.blocos && (this.state.dados.blocos.length >= (this.state.qntDias))){
      modal.open({
        page:<SimpleAlert title="Atenção" message="A quantidade de blocos não deve ser maior que a quantidade de dias" />,
        animation:Alert.ANIMATION_INCREASE
      });
      return false;
    }

    const _ativo = this.state.dados.blocos ? this.state.dados.blocos.length : 0;
    const _arr = this.state.dados.blocos ? this.state.dados.blocos : [];
    const _dados = [..._arr,__args__]
    this.setState({
      dados:{blocos:_dados},
      ativo:_ativo
    });

  }

  toggleBoxes (e){
    e.preventDefault();
    let _id = e.currentTarget.getAttribute("data-id");
    this.setState({ativo:_id});
  }//end toggle boxes

  render (){
    const dadosArray = this.state.dados.blocos ? this.state.dados.blocos : [];
    const qntDias = this.state.qntDias;
    var posDay;
    DAYS.map((value,i)=>{
      if(value.value==qntDias){
        posDay = DAYS[i];
        return false;
      }
    });
    //listagem dos botões
    const listButtons = dadosArray.map((bloco,i)=>{
      const _ativo = this.state.ativo==i ? true : false;
      const _id = i;
        return (
          <BtBloco onClick={this.toggleBoxes} key={i.toString()} value={i+1} ativo={_ativo} dataId={_id}></BtBloco>
        )
      }
    );//end map

    //listagem dos blocos
    const listBlocos = dadosArray.map((bloco,i)=>{
      const _ativo = this.state.ativo==i ? true : false;
      const _className ="";
        return (
          <BlocosBox
            sexo={this.props.sexoAtivo}
            key={i.toString()}
            position={i.toString()}
            bloco={bloco}
            ativo={_ativo}
            onRemoveHandler={this.onRemoveBloco}>
          </BlocosBox>
        )
      }
    );//end map

    const _ativo = "wrapper-bloco-planilha "+this.props.ativarBox;

    const { quantidadeDias, adicionarBloco } = this.state.strings;

    return(
      <div className={_ativo}>
        <a href='#' className='buton-remove-bloco buton-remove-bloco--planilha'><i className="fas fa-times"></i></a>
        <div className="pure-u-15-24">
          <Select key={Math.random()} name='quantidade_dias' onChange={this.handleQntDia} title={quantidadeDias} options={DAYS} value={posDay}/>
        </div>
        <div></div>
        <div>
          <div className="pure-u-15-24">
            <SelectAjax onChange={this.handlerBloco} url={WS.blocos.search}  title={adicionarBloco} />
          </div>
          <div className="pure-u-9-24">
            {listButtons}
          </div>
        </div>
        <div className="js-box-blocos">
          {listBlocos}
        </div>
      </div>
    )
  }
}

export default Component;



// WEBPACK FOOTER //
// ./src/classes/blocos-planilha/Component.js